module.exports = __webpack_public_path__ + "static/media/ST.43f8786b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/ST.svg
// module id = 2266
// module chunks = 7